import React, { Component } from 'react';
import './App.css';
// import CONFIG from './config'
//import { BrowserRoute as Router, Link, Route } from 'react-router-dom';
import { Router, Route, IndexRoute, browserHistory, Redirect } from 'react-router'
import Container from './components/Container'
import Jobs from './components/JobsDashboard'
import Workers from './components/Workers'
import Servers from './components/Servers'
import Dashboard from './components/Dashboard'
import NotFound from './components/NotFound'
import Login from './components/Login'


import Callback from './components/Callback';
import Auth from './Auth/Auth';

const auth = new Auth();
const { isAuthenticated } = auth
console.log('isAuthenticated()', isAuthenticated())
class App extends Component {
  render() {
    return (
      <div className="App">
          <Router history={browserHistory}>
            <Route path='/' component={Login} auth={auth}/>
            {/* <Route path='/'>
              {isAuthenticated() ? <Container msg='VMS Dashboard' auth={auth}>YES</Container> : <Login auth={auth}/>}
            </Route> */}
            <Route path='/callback' component = {Callback} auth={auth}/>
            <Route path='/home' component={Container} auth={auth}>
              <IndexRoute  component = {Dashboard}/>
                <Route path='/jobs' component={Jobs} />
                {/* <Route path='/workers' component={Workers} /> */}
                <Route path='/servers' component={Servers} />
                <Route path='*' component={NotFound} />
            </Route>
          </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js